/**
 * Partner Account IDs
 */
const PARTNERS = {
  WOOP: '100.000.000',
  WOOP_ALT: '100.000.001',
  KEITH: '999.999.999',
  SOLIDARITY: '200.000.000',
  NABU: '200.000.001',
  JOVE: '200.000.002',
  MASS_MUTUAL: '200.000.003',
  STEWART: '200.000.004',
  MERIDIO: '200.000.005',
  WORD_AND_BROWN: '200.000.006',
  ONEIL: '200.000.007',
  PAW: '200.000.008',
  YANCEY: '200.000.014',
  DAVID_AUTO: '200.000.018',
  RAFFERTY: '200.000.020',
  ABELOFF: '200.000.022',
  UNAP: '300.000.000',
  MMEPA: '300.000.001',
  MMNJNYC: '300.000.016',
  LSG: '300.000.007',
  ROUTE_24: '300.000.008',
  FREYSINGER_MAZDA: '300.000.017',
  FREYSINGER_HYUNDAI: '300.000.018',
  FREYSINGER_BUICK_GMC: '300.000.019',
  ABELOFF_BUICK_GMC_KIA: '300.000.021',
  ABELOFF_NISSAN: '300.000.023',
  SCOTT: '200.000.024',
  KELLY: '200.000.019',
  BROWN_DAUB: '200.000.026',
  BROWN_DAUB_CHRYSLER: '300.000.081',
  BROWN_DAUB_ALFA_ROMEO: '300.000.078',
  BROWN_DAUB_CHEVROLET: '300.000.083',
  BROWN_DAUB_HYUNDAI: '300.000.085',
  BROWN_DAUB_CJDR_FIAT: '300.000.082',
  BROWN_DAUB_KIA: '300.000.080',
  BROWN_DAUB_VOLVO: '300.000.079',
  OUTTEN: '200.000.030',
  GEOFF_PENSKE_BUICK_GMC: '300.000.042',
  KELLY_BUICK_GMC: '300.000.053',
  KELLY_CDJR: '300.000.055',
  KELLY_HYUNDAI: '300.000.057',
  KELLY_MITSUBISHI: '300.000.054',
  KELLY_NISSAN: '300.000.056',
  KELLY_TOYOTA: '300.000.058',
  OUTTEN_CDJR_HAMBURG: '300.000.087',
  OUTTEN_CDJR_TAMAQUA: '300.000.088',
  OUTTEN_CHEVY_ALLENTOWN: '300.000.089',
  OUTTEN_CHEVY_HAMBURG: '300.000.090',
  OUTTEN_KIA: '300.000.091',
  GRANITE_RUN_BUICK_GMC: '200.000.031'
};

module.exports = {
  PARTNERS
};
